<script lang="ts">
  export let name: string;
  export let options: { [k in "text" | "value"]: string }[];
  export let onSelect: (selected: string) => void;
  export let extraClasses: string = "";

  // functions
  const onSelectWrapper = e => {
    onSelect(e.target.value);
  };

</script>

<select
  class={"fizz-select fizz-text-strong " + extraClasses}
  {name}
  id={name}
  on:change={onSelectWrapper}
>
  {#each options as option}
    <option value={option.value}>{option.text}</option>
  {/each}
</select>
